import { GraphQLClient } from "../../../../shared/gql-client";
import * as gqlBuilder from "gql-query-builder";
import { gql } from "@apollo/client";
import {
  CarTireSetModel,
  CarTireSetResponseModel,
} from "../../../car/domain/models/carTireSetModel";
import { UpdateTireSetPositionInputModel } from "../../domain/models/updateTireSetPositionInputModel";

export default class TireSetService {
  private client: GraphQLClient | undefined;

  setClient(client: GraphQLClient) {
    this.client = client;
  }

  delete(id: number): Promise<CarTireSetModel> {
    return new Promise((resolve, reject) => {
      const { query, variables } = gqlBuilder.mutation({
        operation: "deleteTireset",
        variables: {
          id: {
            name: "id",
            type: "ID!",
            value: id,
          },
        },
        fields: ["id", "type", "in_hotel", "sleep_set"],
      });

      this.client
        ?.mutate("deleteTireset", gql(query), variables)
        .then((response) => {
          const data = response as CarTireSetResponseModel;

          resolve({
            id: data.id,
            sleepingSet: data.sleep_set,
            inHotel: data.in_hotel,
            car_id: data.car?.id,
            type: data.type,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  updateTiresetPosition(
    variables: UpdateTireSetPositionInputModel,
  ): Promise<CarTireSetResponseModel> {
    return new Promise((resolve, reject) => {
      const { query, variables: gqlVariables } = gqlBuilder.mutation({
        operation: "updateTiresetPosition",
        variables: {
          position_id: {
            value: variables.position_id,
            type: "ID",
          },
          id: { value: variables.id, type: "ID", required: true },
        },
        fields: ["id"],
      });
      this.client
        ?.mutate("updateTiresetPosition", gql(query), gqlVariables)
        .then((response) => {
          resolve(response as CarTireSetResponseModel);
        })
        .catch(reject);
    });
  }
}
